import { render, staticRenderFns } from "./tableBusiness.vue?vue&type=template&id=0ab2a472&scoped=true"
import script from "./tableBusiness.vue?vue&type=script&lang=js"
export * from "./tableBusiness.vue?vue&type=script&lang=js"
import style0 from "./tableBusiness.vue?vue&type=style&index=0&id=0ab2a472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2a472",
  null
  
)

export default component.exports